
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputNumber from '../../commons/form/InputNumber'
import { getObjectWithLocales } from '../../../util/masters/masters'
import regEx from '../../../constants/regEx'
import { handleKeyDown } from '../../../util/utils'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'

class CustomFieldModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      showOrderError: false
    }
  }

  initializeModal (customField) {
    this.props.initialize(customField)
    this.setState({ showOrderError: false })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      const customField = getObjectWithLocales(this.props.customField, this.props.customField?.customFieldLocales ?? [], this.props.languageList)
      this.props.initialize(customField)
      this.setState({ showOrderError: false })
    }
  }

  submitCustomField (values) {
    let customFieldLocales = []
    Object.keys(values).map(item => {
      if (!!values[item] && item.match(regEx.languageFieldName)) {
        customFieldLocales.push(values[item])
      }
    })

    const customField = {
      dossierSubTypeId: this.props.customField?.dossierSubTypeId,
      customFieldId: this.props.customField?.customFieldId,
      code: values.code,
      customFieldTypeId: values.customFieldTypeId,
      viewComponentId: values.viewComponentId || null,
      validationFunction: values.validationFunction || null,
      order: values.order,
      customFieldLocales: customFieldLocales
    }
    this.props.actions.submitCustomField(customField)
  }

  handleOrderBlur (value) {
    if (value && value === '0' && value.toString().trim() !== '') {
      this.setState({ showOrderError: false })
    } else {
      this.setState({ showOrderError: true })
    }
  }

  render () {
    const {
      t, handleSubmit, languageList, showModal,
      combos: { customFieldTypes, viewComponents, dossierSubtypes }
    } = this.props
    const editMode = !!(this.props.customField?.customFieldId)
    const tKey = 'MASTERS.CUSTOM_FIELDS.MODAL.'
    return (
      <Modal id="modalCustomField-Master" className="_nf modalCustomFieldMaster languages-modal" show={showModal} onHide={this.props.actions.closeCustomFieldModal} backdrop="static">
        <form autoComplete="off" onSubmit={handleSubmit(this.submitCustomField.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeCustomFieldModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                disabled={editMode}
                maxLength={20}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="customFieldTypeId"
                controlLabel={t(`${tKey}TYPE`)}
                placeholder={t(`${tKey}TYPE`)}
                valueKey="id"
                labelKey="value"
                options={customFieldTypes}
                disabled={editMode}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="dossierSubTypeId"
                controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                valueKey="id"
                labelKey="value"
                options={dossierSubtypes}
                disabled={true}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="viewComponentId"
                controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                valueKey="id"
                labelKey="value"
                options={viewComponents}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="validationFunction"
                controlLabel={t(`${tKey}VALIDATION_FUNCTION`)}
                placeholder={t(`${tKey}VALIDATION_FUNCTION`)}
                maxLength={50}
              />
              <Field
                component={InputNumber}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="order"
                controlLabel={t(`${tKey}ORDER`)}
                placeholder={t(`${tKey}ORDER`)}
                onHandleBlur = {(value) => this.handleOrderBlur(value)}
                showError={this.state.showOrderError}
                maxLength={4}
              />
            </div>

            <SimpleTablePage
              customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />

          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const requiredErrorMessage = props.t('GLOBAL.FORMS.REQUIRED')
  const errors = { }
  props.languageList?.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = requiredErrorMessage
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = requiredErrorMessage
      }
    } else {
      errors[`lang${language.languageId}`].name = requiredErrorMessage
      errors[`lang${language.languageId}`].description = requiredErrorMessage
    }
  })
  if (!values.code) { errors.code = requiredErrorMessage }
  if (!values.customFieldTypeId) { errors.customFieldTypeId = requiredErrorMessage }
  if (!values.order || values.order === '0' || values.order.toString().trim() === '') { errors.order = requiredErrorMessage }
  return errors
}

export default reduxForm({
  form: 'customFieldModal',
  validate,
  destroyOnUnmount: false
})(CustomFieldModal)
